import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/CONTENT WRITING/CONTENT-WRITING-1900-220.png'
import sidebar from '../../../images/CONTENT WRITING/CONTENT-WRITING-SERVICES.png'

function ContentWriting() {
  useEffect(() => {
    document.title = "Content Writing || OZVASERVICE"
 }, []);

  return (
    <>
      <HeaderImgSection img={slider} hTitle={'Services'}  title={"Content Writing"}></HeaderImgSection>
      <Container className='my-5'>  
        <h1 className='text-center text-primary fw-semibold '>Content Writing</h1>
        <p className='text-center' >At OZVA SERVICE, we specialize in crafting impactful, engaging, and results-driven content that builds trust, boosts brand authority, and drives meaningful traffic to your business. In today’s digital landscape, where content is king — and we help you make every word count.</p>
        <p className='text-center' >Our content writing services are designed around your business goals. Whether you're looking to inform, persuade, or inspire, we create content that resonates with your audience and reflects your unique brand voice. From website copy and blog posts to SEO articles and social media content, we provide custom-written, quality-assured material that strengthens your online presence and supports your growth.</p>

        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Content Writing Services That Deliver Value</h2>
            <p>OZVA SERVICE is a trusted provider of professional content writing solutions, delivering high-quality, research-backed content for brands across a range of industries. Our experienced writers conduct in-depth research into your market, competitors, and trends to ensure your content is accurate, compelling, and strategically aligned with your business objectives.</p>
            <p>We understand that content is more than just writing — it's a powerful tool for visibility, engagement, and conversion. Whether you're a startup seeking exposure or an established business building digital authority, we create content that positions you as a credible and trusted voice in your industry.</p>
            <p>Our services are structured to be both affordable and flexible, giving businesses of all sizes access to high-quality content without overextending their budgets. With quick turnaround times, collaborative communication, and tailored strategies, OZVA SERVICE becomes a reliable extension of your marketing team.</p>
          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        <h2 className='fw-semibold mb-4'>We Can Help You Create Content That Works :</h2>
        <ul>
          <li>Content writing can be complex — but we make it simple, consistent, and results-focused from start to finish.</li>
          <li>With our team of expert writers and data-driven strategies, we produce content that delivers real impact and aligns with your business goals.
          </li>
          <li>From blogs and SEO articles to social media captions and web copy — we offer content solutions that engage, inform, and convert.</li>
        </ul>
        <p className='mb-1'>Have a content requirement or campaign in mind? Contact OZVA SERVICE today — and let us help you tell your brand’s story with clarity, creativity, and confidence.</p>
        {/* <p className='mb-1'></p> */}

      </Container>
    </>
  )
}


export default ContentWriting;